import { ErrorToast } from "../components/toastify";
import { AxiosGetMethod } from "../helpers/customAxios";
import { setShowPreloader } from "../store/activePage";
import HandleLogout from "./handleLogout";

const getTokens = async (dispatch) => {
  dispatch(setShowPreloader(true));
  const getcus = await AxiosGetMethod("customer/get-tokens");
  dispatch(setShowPreloader(false));
  if (getcus?.status === 200) {
    return getcus.data.data;
  } else {
    if (getcus?.status === 401) HandleLogout();
    ErrorToast("Something went wrong on fetching customer data");
    return null;
  }
};
export default getTokens;
